import { useState } from "react";

export interface DataResource {
    data: any;
    setData: (newVal: any) => void;
    isLoading: boolean;
    setIsLoading: (newVal: boolean) => void;
    isLoaded: boolean;
    load: (loader: Promise<any>) => void;
    clear: () => void;
}

const useDataResource = (defaultValue: any = []): DataResource => {
    const [isLoading, setIsLoading] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [data, setData] = useState<any>(defaultValue);

    const load = async (loader: Promise<any>) => {
        setIsLoading(true);
        Promise.resolve(loader)
            .then((result) => {
                setData(result.data);
                setIsLoading(false);
                setIsLoaded(true);
            })
            .catch((error) => {
                console.error('Error fulfilling promise:', error);
            });
    }

    const clear = () => {
        setData(defaultValue);
        setIsLoaded(false);
    }

    return {
        data,
        setData,
        isLoading,
        setIsLoading,
        isLoaded,
        load,
        clear
    }
}

export default useDataResource;